<main
  *ngIf="{
    elements: elements$ | async,
    paginationData: paginationData$ | async,
    isLoading: isLoading$ | async,
    currentError: currentError$ | async,
    onGlobalRefresh: onGlobalRefresh$ | async
  } as STATE"
  class="user-list"
>
  <ng-container *ngIf="!STATE.isLoading && !STATE.currentError">
    <div
      *ngIf="STATE.elements && STATE.elements.length > 0"
      class="user-list__table"
    >
      <article *ngFor="let user of STATE.elements" class="user-list__content">
        <section>
          <div class="user-list__content__logo">
            <img [lazyLoad]="'assets/images/admin.svg'" alt="user icon" />
          </div>

          <div class="user-list__content__text">
            <span class="user-email">{{ user.email ?? '' }}</span>
            <div class="roles-container">
              <ng-container *ngIf="user.roles && user.roles.length > 0">
                <ng-container *ngFor="let role of user.roles; let i = index">
                  <ng-container *ngIf="role | userRole as label">
                    <span class="description" *ngIf="label">
                      {{ label }}
                      <ng-container
                        *ngIf="
                          i < user.roles.length - 1 &&
                          (user.roles[i + 1] | userRole)
                        "
                      >
                        ,
                      </ng-container>
                    </span>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </section>

        <section
          class="user-list__content__icons"
          *ngxPermissionsOnly="['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']"
        >
          <button
            class="button"
            (click)="editUser(user)"
            type="button"
            [matTooltip]="'Modifier l\'utilisateur'"
            aria-label="Modifier l'utilisateur"
          >
            <fa-icon
              primaryColor="var(--info-500)"
              secondaryColor="var(--info-400)"
              [icon]="['fal', 'pen-to-square']"
            ></fa-icon>
          </button>

          <button
            (click)="toggleLockState(user)"
            [matTooltip]="user.locked ? 'Débloquer' : 'Bloquer'"
          >
            <img
              [lazyLoad]="
                user.locked
                  ? 'assets/icons/lock.svg'
                  : 'assets/icons/unlock.svg'
              "
              [alt]="user.locked ? 'Lock icon' : 'Unlock icon'"
            />
          </button>

          <button
            (click)="delete(user)"
            [matTooltip]="'Supprimer ' + user.email"
            aria-label="Supprimer l'utilisateur"
          >
            <img [lazyLoad]="'assets/icons/trash.svg'" alt="Trash icon" />
          </button>
        </section>
      </article>
    </div>

    @if (STATE.elements?.length === 0) {
      <p class="mat-table-container__empty">Aucun utilisateur trouvé</p>
    }

    <mat-paginator
      *ngIf="STATE.elements && STATE.paginationData as pagination"
      (page)="handlePageEvent($event)"
      [length]="pagination.fullyItems"
      [pageIndex]="STATE.elements && pagination.page ? pagination.page - 1 : 0"
      [pageSizeOptions]="[10, 25, 50]"
      [pageSize]="pagination.itemPerPage"
    >
    </mat-paginator>
  </ng-container>

  <loading-or-error
    *ngIf="STATE.isLoading || STATE.currentError"
    (retry)="refreshData()"
    [error$]="currentError$"
    spinnerSize="lg"
  ></loading-or-error>
</main>
